import BaseRepository from './base.repository';

/**
 * Feature Repository
 * Handles API communication for features
 */
class FeatureRepository extends BaseRepository {
  constructor() {
    super('packages');
  }

  /**
   * Get all features grouped by subscription_id
   * @returns {Promise}
   */
  getAllFeatures() {
    return this.client.get('/features');
  }
}

export default new FeatureRepository();

